import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import refreshAuth from "../services/refreshAuth";

function useRefreshAuthMutation(
  setTokenAction: ActionCreatorWithPayload<{ token: string }, string>
) {
  const dispatch = useDispatch();

  return useMutation(
    ["refreshAuth"],
    ({ token }: { token: string }) => refreshAuth({ token }),
    {
      onSuccess: (data) => {
        const newToken = typeof data === "string" ? data : data?.token;

        if (newToken) {
          dispatch(setTokenAction({ token: newToken }));
        } else {
          console.warn("No token received from refresh response");
        }
      },
      onError: (error) => {
        console.error("Token refresh failed:", error);
      },
    }
  );
}

export default useRefreshAuthMutation;
